import * as getEvent from './reducers/get';
import * as open from './reducers/open';
import * as close from './reducers/close';
import * as update from './reducers/update';
import * as create from './reducers/create';
import * as pushRecent from './reducers/push-recent';
import * as minimize from './reducers/minimize';
import * as changeTab from './reducers/change-tab';
import * as search from './reducers/search';

import { simple } from 'src/utils/reducers';

// eslint-disable-next-line import/no-default-export
export default simple({
    EVENT_REQUEST: getEvent.request,
    EVENT_ERROR: getEvent.error,
    EVENT_FINISH: getEvent.finish,

    EVENTS_CREATE_REQUEST: create.request,
    EVENTS_CREATE_ERROR: create.error,
    EVENTS_CREATE_FINISH: create.finish,

    EVENTS_CLOSE_REQUEST: close.request,
    EVENTS_OPEN_REQUEST: open.request,
    EVENTS_OPEN_ERROR: open.error,
    EVENTS_OPEN_FINISH: open.finish,

    EVENTS_UPDATE_REQUEST: update.request,
    EVENTS_UPDATE_ERROR: update.error,
    EVENTS_UPDATE_FINISH: update.finish,

    EVENTS_SEARCH_REQUEST: search.request,
    EVENTS_SEARCH_ERROR: search.error,
    EVENTS_SEARCH_FINISH: search.finish,

    EVENTS_PUSH_RECENT: pushRecent.push,

    EVENTS_DATA: update.bulk,
    EVENT_DATA: update.update,

    EVENTS_MINIMIZE_REQUEST: minimize.request,
    EVENTS_CHANGETAB_REQUEST: changeTab.request,
});
